<template>
  <el-card v-if="isAiAssistant" class="card linkInfoSection">
    <div slot="header">
      <strong class="linkInfoSection__title">Ai 角色配置</strong>
    </div>

    <div class="aiRoleReadonly">
      <div class="aiRoleReadonly__grid">
        <div class="aiRoleReadonly__cell">
          <div class="aiRoleReadonly__label">角色名称</div>
          <div class="aiRoleReadonly__value">{{ roleName }}</div>
        </div>
        <div class="aiRoleReadonly__cell">
          <div class="aiRoleReadonly__label">Model</div>
          <code class="aiRoleReadonly__mono">{{ llmModel }}</code>
        </div>
      </div>

      <div class="aiRoleReadonly__block">
        <div class="aiRoleReadonly__label">Prompt</div>
        <pre class="aiRoleReadonly__pre">{{ promptText }}</pre>
      </div>

      <div v-if="introduction" class="aiRoleReadonly__block">
        <div class="aiRoleReadonly__label">Introduction</div>
        <p class="aiRoleReadonly__text">{{ introduction }}</p>
      </div>

      <div v-if="describe" class="aiRoleReadonly__block">
        <div class="aiRoleReadonly__label">Describe</div>
        <p class="aiRoleReadonly__text">{{ describe }}</p>
      </div>

      <div class="aiRoleReadonly__mediaRow">
        <div v-if="avatar" class="aiRoleReadonly__mediaItem">
          <div class="aiRoleReadonly__label">Avatar</div>
          <el-image class="aiRoleReadonly__img" :src="avatar" :preview-src-list="[avatar]" fit="cover" />
        </div>
        <div v-if="bgL" class="aiRoleReadonly__mediaItem">
          <div class="aiRoleReadonly__label">bgL</div>
          <el-image class="aiRoleReadonly__img" :src="bgL" :preview-src-list="[bgL]" fit="cover" />
        </div>
        <div v-if="bgS" class="aiRoleReadonly__mediaItem">
          <div class="aiRoleReadonly__label">bgS</div>
          <el-image class="aiRoleReadonly__img" :src="bgS" :preview-src-list="[bgS]" fit="cover" />
        </div>
      </div>

      <div v-if="welcome.length" class="aiRoleReadonly__block">
        <div class="aiRoleReadonly__label">Welcome</div>
        <div class="aiRoleReadonly__pillRow">
          <span v-for="(item, index) in welcome" :key="'w-' + index" class="linkInfoPill linkInfoPill--tag">
            {{ item }}
          </span>
        </div>
      </div>

      <div v-if="starters.length" class="aiRoleReadonly__block">
        <div class="aiRoleReadonly__label">Starters</div>
        <div class="aiRoleReadonly__pillRow">
          <span v-for="(item, index) in starters" :key="'s-' + index" class="linkInfoPill linkInfoPill--tag">
            {{ item }}
          </span>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import { normalizeAiRoleStringList } from '../aiAssistantManage/aiAssistantAdapter'

export default {
  name: 'GenericResourceAiAssistantReadonly',
  props: {
    info: { type: Object, required: true },
  },
  computed: {
    isAiAssistant() {
      const type = this.info.assetType || this.info.wallpaperType
      return String(type || '') === 'ai_assistant'
    },
    aiRole() {
      return (this.info.jsonConfig && this.info.jsonConfig.aiRole) || {}
    },
    roleName() {
      return this.aiRole.name || this.info.roleName || '—'
    },
    llmModel() {
      return (this.info.jsonConfig && this.info.jsonConfig.llmModel) || '—'
    },
    promptText() {
      const prompt = this.info.jsonConfig && this.info.jsonConfig.prompt
      if (Array.isArray(prompt) && prompt[0] && prompt[0].content) {
        return prompt[0].content
      }
      return '—'
    },
    introduction() {
      return this.aiRole.introduction || ''
    },
    describe() {
      return this.aiRole.describe || ''
    },
    avatar() {
      return this.aiRole.avatar || this.info.thumbUrl || ''
    },
    bgL() {
      return this.aiRole.bgL || ''
    },
    bgS() {
      return this.aiRole.bgS || ''
    },
    welcome() {
      return normalizeAiRoleStringList(this.aiRole.welcome)
    },
    starters() {
      return normalizeAiRoleStringList(this.aiRole.starters)
    },
  },
}
</script>

<style scoped>
.aiRoleReadonly__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px 32px;
  margin-bottom: 16px;
}

.aiRoleReadonly__cell {
  min-width: 0;
}

.aiRoleReadonly__label {
  margin-bottom: 6px;
  font-size: var(--link-text-sm);
  font-weight: var(--link-font-medium);
  color: var(--link-ink-secondary);
}

.aiRoleReadonly__value {
  font-size: var(--link-text-md);
  color: var(--link-ink);
  word-break: break-word;
}

.aiRoleReadonly__mono {
  font-size: var(--link-text-sm);
  color: var(--link-ink-muted);
  background: var(--link-surface-muted, #f0ebe3);
  padding: 2px 8px;
  border-radius: 6px;
}

.aiRoleReadonly__block {
  margin-bottom: 16px;
}

.aiRoleReadonly__text {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: var(--link-text-md);
  color: var(--link-ink);
}

.aiRoleReadonly__pre {
  margin: 0;
  padding: 12px;
  border-radius: 8px;
  background: var(--link-surface-muted, #f7f4ef);
  border: 1px solid var(--link-line, #eee9e2);
  white-space: pre-wrap;
  word-break: break-word;
  font-size: var(--link-text-sm);
  line-height: 1.5;
}

.aiRoleReadonly__pre--compact {
  max-height: 240px;
  overflow: auto;
}

.aiRoleReadonly__mediaRow {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
}

.aiRoleReadonly__img {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  border: 1px solid var(--link-line, #eee9e2);
}

.aiRoleReadonly__pillRow {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

@media (max-width: 720px) {
  .aiRoleReadonly__grid {
    grid-template-columns: 1fr;
  }
}
</style>
